module.exports = __webpack_public_path__ + "static/media/5CreamAQ5213.dba04fd1.PNG";